// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2fzZQ","row":"styles_row__1TEcq"};